'use client';

import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';
import { useParams } from 'next/navigation';
import { overlay } from 'overlay-kit';
import { useEffect } from 'react';

import BottomSheet from '@/components/common/bottomSheets';
import AppDownload from '@/components/common/bottomSheets/etc/appDownload';
import CommonBackButton from '@/components/common/commonBackBtn';
import memulQueries from '@/service/memul/memulQueries';
import useMobileStore from '@/store/mobileStore';
import { handleSendGAEvent } from '@/utils/google';
import { numberToNormalPrice } from '@/utils/js/number';
import { appToHome, appToShare } from '@/utils/js/webView';

export default function MemulDetailTop() {
  //요약정보 이미지 유무
  const params = useParams();
  const articleCd = params.articleCd;
  const { data } = useQuery({
    ...memulQueries.memulSummary(articleCd as string),
    select: (data) => data.data,
  });

  const { isMobile, isWebView } = useMobileStore();

  useEffect(() => {
    if (data && Boolean(isMobile && !isWebView) && !sessionStorage.getItem('isAppDownloadOpen')) {
      overlay.open(
        ({ isOpen, close }) => {
          return (
            <BottomSheet isOpen={isOpen} close={close} title="">
              <AppDownload close={close} />
            </BottomSheet>
          );
        },
        { overlayId: 'appDownload' },
      );
    }
  }, [data, isMobile, isWebView]);

  // 헤더 스크롤 이벤트
  const headerScrollEvent = () => {
    window.addEventListener('scroll', function () {
      const position = window.scrollY;

      if (position > 0) {
        document.querySelector('.app_bar_detaile')?.classList.remove('top');
      } else {
        document.querySelector('.app_bar_detaile')?.classList.add('top');
      }
    });
  };

  const handlePriceText = ({ businessDivNm, businessDiv, tradePrice, depositPrice }: any) => {
    if (businessDiv === 'M' || businessDiv === 'T') {
      return `${businessDivNm} ${numberToNormalPrice({ value: depositPrice })} / ${numberToNormalPrice({ value: tradePrice })}`;
    } else {
      return `${businessDivNm} ${numberToNormalPrice({ value: tradePrice })}`;
    }
  };

  const noPhotoCondition = (data: any) => {
    const saleInfos = data?.photos?.saleInfos;
    const danjiInfos = data?.photos?.danjiInfos;

    const isSaleInfosImageUrlAllNull =
      Array.isArray(saleInfos) && saleInfos?.every((info: any) => info.imageUrl === null);
    const isDanjiInfosImageUrlAllNull =
      Array.isArray(danjiInfos) && danjiInfos?.every((info: any) => info.imageUrl === null);

    return (
      (saleInfos === null || isSaleInfosImageUrlAllNull) &&
      (danjiInfos === null || isDanjiInfosImageUrlAllNull)
    );
  };

  useEffect(() => {
    headerScrollEvent();
  }, []);

  return (
    <header
      id="header"
      className={classNames('app_bar_top app_bar_detaile top', {
        no_photo: noPhotoCondition(data),
      })}
    >
      <div className="inner">
        {isWebView && (
          <div className="area_leading">
            <CommonBackButton />
          </div>
        )}
        <div className="headline">
          <h1 className="title">{data && handlePriceText(data)}</h1>
        </div>
        {isWebView && (
          <div className="area_trailing">
            <button
              className="btn btn_home"
              onClick={() => {
                handleSendGAEvent('memul_memul_detail_home_btn', {
                  event_category: 'memul',
                });
                appToHome();
              }}
            >
              <span className="text_blind">메인으로</span>
            </button>
            <button
              className="btn btn_share"
              onClick={() => {
                handleSendGAEvent('memul_memul_detail_share_btn', {
                  event_category: 'memul',
                });
                appToShare(window.location.href);
              }}
            >
              <span className="text_blind">공유하기</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
